import { JSApiList } from 'wx-jssdk';

export const API_PREFIX = '/caizhi_miniapi/';
export const API_ACTIVITY_PREFIX = '/caizhi_activity/';
export const API_APPLET = '/applet/';
export const API_CMT_PREFIX = '/cmt_miniapi/';
export const API_CMT_ACTIVITY_PREFIX = '/cmt_activity/';

// 需要 agentConfig 鉴权的接口列表
export const WX_AGENT_CONFIG_JSAPI_LIST: string[] = [
  'selectExternalContact', // [外部联系人选人接口]
  'openUserProfile', // [打开个人信息页接口]
  'thirdPartyOpenPage', // [自建、第三方应用：发起审批、查看审批详情]
  'getCurExternalContact', // [获取当前外部联系人userid]
  'sendChatMessage', // [分享消息到当前会话]
  'getCurExternalChat', // [获取当前客户群的群ID]
  'getContext', // [获取进入H5页面的入口环境]
  'launchMiniprogram', // [跳转到小程序]
  'shareToExternalContact', // [群发消息给客户]
  'navigateToAddCustomer', // [进入添加客户界面]
  'startLiving', // [创建立即直播]
  'replayLiving', // [观看直播回放]
  'shareToExternalMoments', // [发表内容到客户朋友圈]
  'shareToExternalChat', // 分享到客户群
  'shareTimeline',
];

// 需要使用的通用SDK接口列表
export const WX_DEFAULT_JSAPI_LIST: JSApiList[] | JSApiList = [
  'onMenuShareAppMessage',
  'onMenuShareTimeline',
  'onMenuShareWechat',
  'getLocation',
  'previewImage',
  'hideOptionMenu',
  'showOptionMenu',
  'showMenuItems',
  'shareAppMessage',
  'shareWechatMessage',
  'onMenuShareTimeline',
  'openEnterpriseChat',
  'hideAllNonBaseMenuItem',
  'hideMenuItems',
  'previewFile',
  'chooseImage',
  'getLocalImgData',
  'uploadImage',
  'getLocation',
  'closeWindow',
  // 微信端API
  'updateAppMessageShareData',
  'updateTimelineShareData',
];

export const AJAX_CODE = {
  productDown: 1010089, // 产品删除、下架
  articleDown: 50020001, // 文章删除
  productDel: 50011002, // 产品删除
  activityDown: 1010090, // 活动删除
  livingDown: 1010099, // 直播下架、删除
};

// 路由白名单
export const routerWhiteNameList = ['error'] as const;
// 当前运行环境信息
export const WECHAT_ENV = {
  qyWechat: 1, // 企业微信
  wechat: 2, // 微信
};

// 业务中有引用到，于是提取出来
export const CORP_ID_GUANGDA = 'ww7726587648cdc3da'; // 光大银行
export const CORP_ID_JIANGYIN = 'wwad758ffe1ebca931'; // 江阴农商银行
export const CORP_ID_XIAMEN = 'ww9d09288d837bf4da'; // 厦门银行
export const CORP_ID_DEV = 'wwc8b0e2b9d33c6340'; // 新皓信息  dev
export const CORP_ID_TEST = 'ww8c83d949a80b562d'; // 新翰信息咨询合伙企业  test
export const CORP_ID_TEST2 = 'ww29ca23e4addefa92'; // 新皓                test2
export const CORP_ID_UAT = 'ww2c6ff24bf8608b5b'; // 新翰信息            uat
export const CORP_ID_TEST3_1 = 'ww9038af1337f90eaa'; // test3
export const CORP_ID_TEST3_2 = 'ww03a52391aa4bafdb'; // test3

// PC端企业微信 在推产品、发咨询、每日早报中支持转发（群发客户、群发客户群两种分享方式）的企业id集合
export const SUPPORT_FORWARD_PC_QYWECHAT_CORP_IDS = [
  CORP_ID_DEV, // 开发环境
  'ww8c83d949a80b562d', // 新翰信息咨询合伙企业-test
  // 'wwbff7045d42600f88', // 腾银信息-test
  'ww29ca23e4addefa92', // 新皓-test2
  'ww2c6ff24bf8608b5b', // 新翰信息-uat
  'ww535912ccc9fb5be5', // 腾银-正式
  /* -------------------------------------------------- */
  'ww5f03d548ea0cdb35', // 宁波银行
];
// 活动类型obj
export const BANNER_TYPE = {
  article: 0,
  product: 1,
  link: 2,
  picture: 3,
  miniPro: 4,
  renwubao: 5,
};

// 功能配置白名单
export const SCRAP_DATA_IS_IN_WHITE_LIST = {
  PRODUCT_PREHEAT_SETTTING: 'PRODUCT_PREHEAT_SETTTING', // 产品预热设置开关
  POSTER_QRCODE_PROMPT: 'POSTER_QRCODE_PROMPT', // 海报配置产品二维码下的提示文字配置
  LIVE_PREHEAT_SETTTING: 'LIVE_PREHEAT_SETTTING', // 直播白名单
};

export const CUSTOMER_RECORD_TYPE = {
  chatMeInProduct: 40, // 产品详情页联系我
};

// 后端行为埋点类型 api: api/applet/dynamics/save.do
// 20:直播点击回放生成中,21:节点关怀-点击话题,22:节点关怀-点击活动banner,
// 24:产品查看访问渠道,25:个人名片-点击查看图片,26:个人名片-点赞了印象标签,
// 27:节点关怀-点击产品，28：节点关怀-点击报名参与，29：节点关怀-点击报名不参与，
// 30：文章感兴趣，31：文章不感兴趣 40：详情页点击联系我，
// 81：财富晚报-点击互动话题，82：财富晚报-点击看涨，83：财富晚报-点击看跌
export enum RadarRecordType {
  thumb = 5, // 点赞 感兴趣
  handle = 15, // 前往办理
  orderApply = 16, // 预约申请
  liveOrder = 17, // 直播点击立即预约
  liveWatch = 18, // 直播点击立即观看
  liveBackWatch = 19, //直播点击观看回放
  sellTip = 23, //开售提醒
  sendWant = 90, // 发送期待
}

export const CORP_ID_CHINA_BANK = 'wwbeea07437d5961e6'; // 中国银行
export const CORP_ID_MIN_SHENG = 'ww51ab38ddb9f7f60d'; // 民生银行
export const CORP_ID_TYXX = 'wwbff7045d42600f88'; // 腾银信息
// 测试2、腾银、光大显示小站tab
export const STATION_SHOW_TAB_WHITE_LIST = [
  'wwae9c3475c024f743',
  'ww535912ccc9fb5be5',
  'ww7726587648cdc3da',
  CORP_ID_CHINA_BANK,
];
// 浦发白名单
export const SPDB_WHITE_LIST = ['wx9e4581952618ab88']; // wwbff7045d42600f88测试环境 腾银信息  wwc6d4d326f16d24d2 uat深圳腾银信息

// 主推产品位置 - 小站 3  推产品 11
export const PRODUCT_SCENE_TYPE = {
  sttion: 3,
  pushGoods: 11,
};

// 关联产品的类型
export enum RELATE_PRODUCT_TYPE {
  article = 'article', // 文章
  paper = 'paper', // 早报
  eveningPaper = 'eveningPaper', // 晚报
  articleTopic = 'newsSubject', // 资讯专题
  questionnaire = 'questionnaire', // 问卷
  banner = 'banner', // banner
}

// 弹窗类型
export const POPUP_TYPE = {
  article: 0,
  product: 1,
  link: 2,
  picture: 3,
  miniPro: 4,
};

// 苏州银行--模拟企业
const YaoJinCorpId = 'ww36b98e83f52f6bcc';
const TYinCZCorpId = 'ww535912ccc9fb5be5';
const SuZhouBankCorpId = 'ww4d7d6acdcb5c01f8';
export const SZ_BANK_LIST = [CORP_ID_DEV, CORP_ID_TEST, CORP_ID_UAT, TYinCZCorpId, YaoJinCorpId, SuZhouBankCorpId];

export * from './modules/constants-product';
export * from './modules/constants-card';
export * from './modules/constants-recommendPosition';
export * from './modules/constants-poster';
export * from './modules/constants-resource';
